/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
import { confirmAlert } from 'react-confirm-alert'; //알럿창(alert confirm)
// import parse from "html-react-parser";

class CouponItem extends PureComponent {
  state = {};
  _couponConfirm = () => {
    confirmAlert({
      title: '쿠폰사용',
      message:
        '선택하신 쿠폰을 사용하시겠습니까? 사용된 쿠폰은 환불/재발급 되지 않습니다.?',
      buttons: [
        {
          label: '사용하기',
          onClick: () => {
            this._useCoupon();
          },
        },

        {
          label: '취소',
        },
      ],
    });
  };

  _useCoupon = async () => {
    const { loginId } = this.props;
    const { couponNo, _getData } = this.props.childProps;

    if (loginId === '' || loginId === undefined || loginId === null) {
    } else {
      const result = await this._useCouponApi(couponNo);
      if (result) {
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          toast.success('쿠폰 사용이 성공적으로 이루어졌습니다.');
          _getData(1);
        } else if (intReturn === -4) {
          toast.error('이미 사용된 쿠폰번호 입니다.');
        } else if (intReturn === -3) {
          toast.error('유효기간이 만료된 쿠폰입니다.');
        } else if (intReturn === -2) {
          toast.error('쿠폰번호가 잘못되었습니다.');
        } else if (intReturn === -5) {
          toast.success(
            '멤버십을 이용시 사용이 불가합니다. 멤버십 종료후 이용해 주세요.'
          );
        } else {
          toast.success('등록중 오류가 발생했습니다.');
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _useCouponApi = (couponNo) => {
    const { apiUrl, loginId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');
    return axios
      .post(
        apiUrl + '/myCouponUse',
        {
          params: {
            userid: loginId,
            couponNo: couponNo,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async () => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._useCoupon();
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  render() {
    // const { loginId } = this.props;

    const {
      couponNo,
      couponPartName,
      couponGubun,
      limitDay,
      startDate,
      endDate,
    } = this.props.childProps;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <ul>
          <li className="coupon">
            <div className="coupon_txt">
              <img src={imgUrl + '/img/mypage/coupon_logo.png'} />
              <p>{limitDay} 멤버십</p>
            </div>
          </li>
          <li className="info">
            <div className="name">{couponPartName}</div>
            <div className="con">
              <dl>
                <dt>쿠폰혜택</dt>
                <dd>
                  {couponGubun === 'P'
                    ? '멤버십(다운로드 가능)'
                    : '멤버십(다운로드 불가)'}{' '}
                  {limitDay}일 이용권
                </dd>
              </dl>
              <dl>
                <dt>쿠폰번호</dt>
                <dd>{couponNo}</dd>
              </dl>
              <dl>
                <dt>유효기간</dt>
                <dd>
                  {startDate} ~ {endDate}
                </dd>
              </dl>
              <dl>
                <dt>이용안내</dt>
                <dd>
                  유효기간이내에 사용해주세요. 유효기간이 지난 쿠폰은 자동으로
                  소멸됩니다.
                </dd>
              </dl>
            </div>
          </li>
          <button
            type="button"
            className="btn_coupon"
            onClick={this._couponConfirm}
          >
            쿠폰사용
          </button>
        </ul>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(CouponItem));
